export default __webpack_public_path__ + "9b03ae8091b637009e946be10db3f99c.png";